// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"252":"5fef3108","395":"f2589bcc","437":"87e68f3c","443":"cd9bfb46","513":"89f89a0a","547":"7ee1c025","577":"cfabd2ef","798":"29bb06eb"}[chunkId] + ".chunk.js";
};